import React from "react";
import { Input } from "antd";

const UIInput = ({
  placeholder = "",
  value = "",
  size = "middle",
  style,
  className,
  onchange = () => {},
  onPressEnter = () => {},
  suffix,
  required = false, 
  allowClear = false,
  onSearch = false
}) => {
  return (
    <div style={{ width: "100%" }}>
      {required && <div style={{ color: "red" }}>*</div>}
    <Input
    suffix={suffix}
      className={className}
      style={style}
      size={size}
      placeholder={placeholder}
      value={value}
      allowClear={allowClear}
      onSearch={onSearch}
      onChange={(e) => {
        onchange(e.target.value);
      }}
      onPressEnter={onPressEnter}
    />
    </div>
  );
};

export default UIInput;
